import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { MdLogout, MdSettings } from "react-icons/md";
import { API_BASE_URL } from '../../creds';

const ProfileSection = ({
  isOpen = false,
  onLogout = () => {},
}) => {
  const [user, setUser] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [imageError, setImageError] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userLogin"));
    setUser(storedUser || { name: "Guest", email: "guest@example.com" });
  }, []);

  const firstLetter = user?.userName
    ? user.userName.charAt(0).toUpperCase()
    : "G";

  const handleImageError = () => {
    setImageError(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setImageError(false);
  }, [user?.userProfileImage]);

  const sidebarWidth = isOpen ? "w-[250px]" : "w-[70px]";
  const usernameFormatted = (user?.userName || "Guest")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <div
      className={`fixed bottom-0 left-0 ${sidebarWidth} bg-gray-100 p-2 z-[1000]`}
    >
      <button
        className={`w-full flex items-center p-2 bg-transparent hover:bg-gray-200 transition rounded`}
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <MdSettings size={44} />
        <span
          className={`ml-2 text-2xl transition-all duration-300 ${isOpen || 'group-hover:opacity-100 group-hover:w-auto opacity-0 w-0'
          } ${isOpen ? 'opacity-100 w-auto' : 'overflow-hidden'}`}
        >
          {usernameFormatted}
        </span>
      </button>

      {showDropdown && (
        <div
          ref={dropdownRef}
          className="absolute left-0 bottom-[50px] w-[270px] max-h-screen overflow-y-auto bg-white rounded shadow p-4 z-[1001]"
        >
          <div className="flex justify-center mb-4">
            {imageError || !user?.userProfileImage ? (
              <div className="w-[80px] h-[80px] flex items-center justify-center rounded-full bg-blue-600 text-white font-bold text-sm">
                {firstLetter}
              </div>
            ) : (
              <img
                src={`${API_BASE_URL}/ProfileImages/${user.userProfileImage}`}
                alt={user?.userName || "User"}
                className="w-[80px] h-[80px] object-cover rounded-full border"
                onError={handleImageError}
              />
            )}
          </div>
          <p className="text-sm mb-1">
            <span className="font-semibold">Name:</span>{" "}
            {usernameFormatted}
          </p>
          <p className="text-sm mb-4">
            <span className="font-semibold">Email:</span>{" "}
            {user?.userEmail || "No email"}
          </p>
          <hr className="my-3" />
          <button
            className="w-full flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white py-2 rounded text-sm transition"
            onClick={onLogout}
          >
            <MdLogout size={20} /> Logout
          </button>
        </div>
      )}
    </div>
  );
};

ProfileSection.propTypes = {
  user: PropTypes.shape({
    userName: PropTypes.string,
    userEmail: PropTypes.string,
    userProfileImage: PropTypes.string,
  }),
  isExpanded: PropTypes.bool.isRequired,
  onLogout: PropTypes.func.isRequired,
};

export default ProfileSection;

